// deployment_class: customer_env_allowed
/**
 * Tier-2 account-admin surface registrations (Settings & Account IA spec
 * 2026-06-24, zone `settings.account` → `/account/organization/*`). The
 * customer's own self-governance area.
 *
 * Scope-gated so the org profile is visible to anyone who can read the org
 * (e.g. the PHA CEO), while the administrative surfaces (members, billing,
 * integrations) are visible only to the holder of the matching account_admin
 * scope. Visibility is the §9 layer-6 render-gate — it sits ON TOP of the
 * backend default-deny, never instead of it.
 */
import { registerSurface, getSurfaces } from '../csa-surface/registry';

export function registerAccountAdminSurfaces(): void {
  if (getSurfaces('settings.account').length > 0) return; // idempotent

  registerSurface({
    id: 'organization',
    zone: 'settings.account',
    label: 'Organization',
    order: 10,
    requiredScope: 'read:organization',
    deploymentClass: 'customer_env_allowed',
    component: () =>
      import('./sections/account-admin-sections').then((m) => ({
        default: m.OrganizationProfileSection,
      })),
  });

  registerSurface({
    id: 'members',
    zone: 'settings.account',
    label: 'Members & roles',
    order: 20,
    requiredScope: 'write:members',
    deploymentClass: 'customer_env_allowed',
    component: () =>
      import('./sections/account-admin-sections').then((m) => ({ default: m.MembersSection })),
  });

  registerSurface({
    id: 'billing',
    zone: 'settings.account',
    label: 'Billing & subscription',
    order: 30,
    requiredScope: 'manage:billing',
    deploymentClass: 'customer_env_allowed',
    component: () =>
      import('./sections/account-admin-sections').then((m) => ({ default: m.BillingSection })),
  });

  registerSurface({
    id: 'integrations',
    zone: 'settings.account',
    label: 'Integrations',
    order: 40,
    requiredScope: 'manage:webhooks',
    deploymentClass: 'customer_env_allowed',
    component: () =>
      import('./sections/account-admin-sections').then((m) => ({
        default: m.IntegrationsSection,
      })),
  });
}
